import { render, staticRenderFns } from "./DesignFontSelect.vue?vue&type=template&id=5a3eecee&scoped=true&"
import script from "./DesignFontSelect.vue?vue&type=script&lang=js&"
export * from "./DesignFontSelect.vue?vue&type=script&lang=js&"
import style0 from "./DesignFontSelect.vue?vue&type=style&index=0&id=5a3eecee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3eecee",
  null
  
)

export default component.exports